/**
	À décommenter et modifier pour changer le breakpoint activant les animations parallax
	activé par défaut à partir des tablettes (768)
 **/
parallaxBreakpoint = 768;

(function ($) {

	function parallaxIt(e, target, movement, x, y, delay) {

		var $this = target.closest('.mouse-animated');
		var relX = e.pageX - $this.offset().left;
		var relY = e.pageY - $this.offset().top;
		delay = delay || 0;

		TweenMax.to(target, 2, {
			x: (relX - $this.width() / x) / $this.width() * movement,
			y: (relY - $this.height() / y) / $this.height() * movement,
			rotation: 0.01,
			delay: delay,
			force3D: false
		});
	}

	function InitHomePage() {

		var $slickElement = $('.slider-bp');

		if ($slickElement.length) {
			$slickElement.slick({
				infinite: true,
				nextArrow: '.slick-next',
				prevArrow: '.slick-prev',
				slidesToShow: 2,
				slidesToScroll: 1,
				asNavFor: '.slider-bp-open',
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});
		}

		$('.close-bp-open, .close-bp-open-div').on('click', function () {
			$('.container-slider-bp-open').removeClass('is-open');
			$('body').removeClass('noscroll');
		});

		if ($('.nav-slider__counter').length) {
			var $slideCurrent = $('.counter__current');
			var $slideTotal = $('.counter__total');

			$slideCurrent.text(1);
			$slideTotal.text($slickElement.find('.slide-bp:not(".slick-cloned")').length);

			$slickElement.on('afterChange', function (event, slick, currentSlide, nextSlide) {
				$slideCurrent.text(currentSlide + 1);
			});
		}

		//SLIDER BP OPEN
		var $slickElement2 = $('.slider-bp-open');

		if ($slickElement2.length) {
			$slickElement2.slick({
				nextArrow: '.slick-next-open',
				prevArrow: '.slick-prev-open',
				asNavFor: '.slider-bp',
				fade: true
			});
		}

		//SLIDER ACTIVITES
		var $slickElement3 = $('.slider-act');

		if ($slickElement3.length) {
			$slickElement3.slick({
				nextArrow: '.slick-next2',
				prevArrow: '.slick-prev2',
				asnav: '.nav-slider-act',
				autoplay: true,
				fade: true
			});
		}


		$('a[data-slide]').click(function (e) {
			e.preventDefault();
			var slideno = $(this).data('slide');
			$('.slider-act').slick('slickGoTo', slideno - 1);
		});


		// Event to initiate drag, include touchstart events
		$('.slide-item, .container-bloc-envie').on('mousedown', function (e) {

			var move = 0;

			// Event to end drag, may want to include touchend events
			$(this).one('mouseup', function (e) {

				$(this).off('mousemove');

				if (move == 0) {

					$('.slide-bp').on('click', function () {
						if (!$(this).hasClass('slick-current')) {
							$slickElement.slick('slickNext');
						}
						$('.container-slider-bp-open').addClass('is-open');
						$('body').addClass('noscroll');
					});


					$('[data-link]').click(function (e) {
						linkHandler($(this));
					}).find('a').click(function (e) {
						e.stopPropagation();
					});

				}

			}).on('mousemove', function (e) {

				$('[data-link]').unbind('click');
				$('.slide-bp').unbind('click');


				move = e.pageX;

			});

		});
	}

	/*
	########   ########      ###     ##    ##    ######    ####  ########   
	   ##      ##     ##    ## ##    ###   ##   ##    ##    ##      ##      
	   ##      ##     ##   ##   ##   ####  ##   ##          ##      ##      
	   ##      ########   ##     ##  ## ## ##    ######     ##      ##      
	   ##      ##   ##    #########  ##  ####         ##    ##      ##      
	   ##      ##    ##   ##     ##  ##   ###   ##    ##    ##      ##      
	   ##      ##     ##  ##     ##  ##    ##    ######    ####     ##      
	*/

	var Homepage = Barba.BaseView.extend({
		namespace: 'template-home',
		onEnter: function () {
			// The new Container is ready and attached to the DOM.
			InitHomePage();
		},

		onEnterCompleted: function () {
			$('body').removeClass('noscroll');
		},
		onLeave: function () {
			// A new Transition toward a new page has just started.
		},
		onLeaveCompleted: function () {
			// The Container has just been removed from the DOM.
		}
	});

	Homepage.init();
	Barba.Pjax.start();
	Barba.Prefetch.init();

	// Don't forget to init the view!
	var FadeTransition = Barba.BaseTransition.extend({
		start: function () {
			/**
			 * This function is automatically called as soon the Transition starts
			 * this.newContainerLoading is a Promise for the loading of the new container
			 * (Barba.js also comes with an handy Promise polyfill!)
			 */
			// As soon the loading is finished and the old page is faded out, let's fade the new page
			$('.transition').addClass('play');
			$('body').removeClass('ctrlParallax');
			var promise = this;
			setTimeout(function () {
				promise.newContainerLoading.then(promise.finish.bind(promise));
			}, 900);
		},

		finish: function () {
			$('html, body').animate({scrollTop: 0}, 0);
			$('.transition').removeClass('play');
			var mh = [];
			setTimeout(function () {
				$('[data-mh]').each(function () {
					mh.push($(this).data('mh'));
				});
				$.each(mh, function (element, value) {
					$.fn.matchHeight._apply('[data-mh="' + value + '"]');
				});
			}, 200);
			this.done();

			$('body').removeClass('noscroll');

		}
	});

	/**
	 * Next step, you have to tell Barba to use the new Transition
	 */

	Barba.Pjax.getTransition = function () {

		/**
		 * Here you can use your own logic!
		 * For example you can use different Transition based on the current page or link...
		 */
		return FadeTransition;
	};

	Barba.Dispatcher.on('transitionCompleted', function (currentStatus, oldStatus) {
		pageInit();
	});

	Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

	Barba.Pjax.preventCheck = function (evt, element) {
		if (!Barba.Pjax.originalPreventCheck(evt, element)) {
			return false;
		}

		if(element.getAttribute("href").indexOf(".pdf") > -1){
			return false;
		}

		if ($(element).closest('#wpadminbar').length > 0) {
			if (evt.type == "click") {
				linkHandler($(element));
			}
			return false;
		}
		return true;
	};


	/*
	########   ########    ######    ####  ########   ########   
	##     ##  ##         ##    ##    ##        ##    ##         
	##     ##  ##         ##          ##       ##     ##         
	########   ######      ######     ##      ##      ######     
	##   ##    ##               ##    ##     ##       ##         
	##    ##   ##         ##    ##    ##    ##        ##         
	##     ##  ########    ######    ####  ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/

	/* Fonctions exécutées à chaque resize */
	function resizeHandler() {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();
	}

	function openReservationHandler() {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'openReservation'
		});
	}


	/*
	####  ##    ##   ####  ########   
	 ##   ###   ##    ##      ##      
	 ##   ####  ##    ##      ##      
	 ##   ## ## ##    ##      ##      
	 ##   ##  ####    ##      ##      
	 ##   ##   ###    ##      ##      
	####  ##    ##   ####     ##      
	*/

	function pageInit() {

		$('.btn-menu-mobile-open').on('click', function () {
				$('body').addClass('noscroll');
				$('.container-nav-menu').addClass('container-nav-menu-visible');
				$('.btn-menu-mobile-open').addClass('btn-menu-mobile-open-hidden');
				$('.btn-menu-mobile-close').addClass('btn-menu-mobile-close-visible');
			}
		);

		$('.btn-menu-mobile-close').on('click', function () {
				$('body').removeClass('noscroll');
				$('.container-nav-menu').removeClass('container-nav-menu-visible');
				$('.btn-menu-mobile-open').removeClass('btn-menu-mobile-open-hidden');
				$('.btn-menu-mobile-close').removeClass('btn-menu-mobile-close-visible');

			}
		);

		//SCROLL-TOP
		var scrollTop = $(".scroll-top");
		var containerScrollTop = $(".container-fixed");

		$(document).on('scroll', function () {
			showScrollTop();
		});

		function showScrollTop() {
			var topPos = $(document).scrollTop();
			// if user scrolls down - show scroll to top button
			if (topPos > 350) {
				$(containerScrollTop).css("opacity", "1");
			} else {
				$(containerScrollTop).css("opacity", "0");
			}
		}

		$(scrollTop).click(function () {
			$('html, body').animate({
				scrollTop: 0
			}, 800);
			return false;

		});

		var box = $('#head'),
			docHeight = document.documentElement.offsetHeight;
		window.addEventListener('scroll', function () {
			// normalize scroll position as percentage
			var scrolled = 1 + window.scrollY / (docHeight - window.innerHeight + 5000),
				transformValue = 'scale(' + scrolled + ')';
			box.css('transform', transformValue);
		}, false);

		new Dragdealer('drag-envies', {
			css3: true,
			loose: true,
			requestAnimationFrame: true
		});

		// Desactivation lien actif
		var links = document.querySelectorAll('a[href]');
		var cbk = function (e) {
			if (e.currentTarget.href === window.location.href) {
				e.preventDefault();
				e.stopPropagation();
			}
		};

		for (var i = 0; i < links.length; i++) {
			links[i].addEventListener('click', cbk);
		}

		// Mouse animated
		if ($('.mouse-animated').length > 0) {
			$('.mouse-animated').each(function () {
				$(this).mousemove(function (e) {
					if ($(this).find('.mouse-1').length > 0) {
						parallaxIt(e, $(this).find('.mouse-1'), -10, 1, 1);
					}
					if ($(this).find('.mouse-2').length > 0) {
						parallaxIt(e, $(this).find('.mouse-2'), 25, 1, 0.8);
					}
					if ($(this).find('.mouse-3').length > 0) {
						parallaxIt(e, $(this).find('.mouse-3'), -25, 1, 0.6);
					}
					if ($(this).find('.mouse-4').length > 0) {
						parallaxIt(e, $(this).find('.mouse-4'), -10, 10, 2);
					}
				});
			});
		}

		// Déclaration des évènements
		$(window).off('resize orientationchange').on('resize orientationchange', addEndEvent);
		$(window).off('resizeEnd').on('resizeEnd', resizeHandler);
		$('body').off('reveal').on('reveal', '.sr', scrollRevealHandler);

		$(window).trigger('resize'); // Joue la fonction resizeHandler()
		formLoader();                // Affiche un 'cache' à la validation d’un form CF7

		// Local smooth scroll sur les liens vers des ancres
		if ($('.localscroll').length > 0) {
			$('.localscroll').localScroll({
				hash: true
			});
			$.localScroll.hash();
		}

		if ($('.fitvids').length > 0) {
			$('.fitvids').fitVids();
		}

		$('[data-link]').click(function (e) {
			// $(this).find('a').trigger('click');
			Barba.Pjax.goTo($(this).data('link'));
		});

		//SLIDER PAGE BLOCK TEXT IMG
		var $sliderTextImg = $('.block-text-img-slider');

		$sliderTextImg.each(function (index, elem) {
			var prev = $(elem).parent().find('.slick-prev');
			var next = $(elem).parent().find('.slick-next');

			$(elem).slick({
				arrows: false,
				dots: false,
				autoplay: true,
				fade: true
			});

			prev.on('click', function () {
				$(elem).slick('slickPrev');
			});

			next.on('click', function () {
				$(elem).slick('slickNext');
			});
		});

		//SLIDER PAGE BLOCK MEDIA
		var $slickElement4 = $('.block-text-media-slider');

		if ($slickElement4.length) {
			$slickElement4.slick({
				nextArrow: '.slick-next-media-slider',
				prevArrow: '.slick-prev-media-slider',
				autoplay: true,
				fade: true
			});
		}

		//SLIDER PAGE BLOCK SLIDER
		var $slickElement5 = $('.block-slider-slides');

		if ($slickElement5.length) {
			$slickElement5.slick({
				nextArrow: '.slick-next-block-slider',
				prevArrow: '.slick-prev-block-slider',
				autoplay: true,
				fade: true
			});
		}

		if ($('.nav-slider__counter-block-slider').length) {
			var $slideCurrent = $('.counter__current');
			var $slideTotal = $('.counter__total');

			$slideCurrent.text(1);
			$slideTotal.text($slickElement5.find('.block-slider-slide').length);

			$slickElement5.on('afterChange', function (event, slick, currentSlide, nextSlide) {
				$slideCurrent.text(currentSlide + 1);
			});
		}


		/* 
		######     #######   ##    ##   ########      ###      ######    ########   
		##    ##   ##     ##  ###   ##      ##        ## ##    ##    ##      ##      
		##         ##     ##  ####  ##      ##       ##   ##   ##            ##      
		##         ##     ##  ## ## ##      ##      ##     ##  ##            ##      
		##         ##     ##  ##  ####      ##      #########  ##            ##      
		##    ##   ##     ##  ##   ###      ##      ##     ##  ##    ##      ##      
		######     #######   ##    ##      ##      ##     ##   ######       ##      
		*/
		var contactFormInputs = $('.contact-form input, .contact-form textarea');
		contactFormInputs.on('focus', function () {
			$('.contact-form .label-container').removeClass('active');
			$(this).closest('li').find('.label-container').addClass('active');
		});

		contactFormInputs.on('blur', function () {
			$('.contact-form .label-container').removeClass('active');
			if ($(this).val().length) {
				$(this).closest('li').find('.label-container').addClass('filled');
			} else {
				$(this).closest('li').find('.label-container').removeClass('filled');
			}
		});

		/*
		########   ########   ########   ########    ######    ########    ######
		##         ##         ##         ##         ##    ##      ##      ##    ##
		##         ##         ##         ##         ##            ##      ##
		######     ######     ######     ######     ##            ##       ######
		##         ##         ##         ##         ##            ##            ##
		##         ##         ##         ##         ##    ##      ##      ##    ##
		########   ##         ##         ########    ######       ##       ######
		*/

		$('.video-pres-pop').magnificPopup({
			type: 'iframe',
			removalDelay: 300,
			mainClass: 'mfp-fade mfp-fade-video'
		});

		$('.iframe-resa').magnificPopup({
			type: 'iframe',
			removalDelay: 300,
			mainClass: 'mfp-fade',
			closeOnBgClick: false,
			enableEspaceKey: true,
			callbacks: {
				open: openReservationHandler
			}
		});

		$('.search-resa-submit').click(function (e) {
			e.preventDefault();

			$saison = $(this).parent().find("select[name='saison'] option:selected");
			$nombre = $(this).parent().find("select[name='nombre'] option:selected");

			var params = {
				saison: $saison.val(),
				nombre: $nombre.val()
			};
			var url = $(this).attr('href') + '?' + $.param(params);

			if (params.nombre == 'more') {
				window.location = $nombre.data('redirect') + '?more';
			} else {
				$.magnificPopup.open({
					items: {
						src: url
					},
					type: 'iframe',
					removalDelay: 300,
					mainClass: 'mfp-fade',
					closeOnBgClick: false,
					enableEspaceKey: true,
					callbacks: {
						open: openReservationHandler
					}
				});
			}
		});

		new Buttons();
		new BlockCollapse();
		new BlockGallery();
		new BlockListingAppart();
		new Nav();
	}

	// Initialisation de toutes les fonctions utiles au chargement de la page
	$(function () {
		pageInit();
	});

})(jQuery);
